module.exports = " <div class=\"ui-cmp-tab headless\"> <ul class=head> </ul> <span class=\"ul-left hover icon-corner-left\"></span> <span class=\"ul-right hover icon-corner-right\"></span> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/js/common/uikit/template/tabTpl.html
// module id = 263
// module chunks = 0